import type { CreateBranchRequest } from '@/bindings/CreateBranchRequest'
import type { Currency } from '@/bindings/Currency'
import type { Timezone } from '@/bindings/Timezone'
import { DEFAULT_CURRENCY } from '@/lib/currencies'
import { defaultTimezone } from '@/lib/timezones'
import { currencyForTimezone } from '@/lib/zone-currency'

export interface BranchDraft {
  name: string
  slug: string
  /** Once the admin edits the slug by hand, the name stops drafting it. */
  slugEdited: boolean
  timezone: Timezone
  currency: Currency
  /** Likewise, a hand-picked currency stops following the zone. */
  currencyEdited: boolean
}

export function emptyBranchDraft(): BranchDraft {
  const timezone = defaultTimezone()
  return {
    name: '',
    slug: '',
    slugEdited: false,
    timezone,
    currency: currencyForTimezone(timezone) ?? DEFAULT_CURRENCY,
    currencyEdited: false,
  }
}

/** The zone's country decides the currency until the admin picks one (2026-10-02). */
export function withTimezone(draft: BranchDraft, timezone: Timezone): BranchDraft {
  const followed = draft.currencyEdited ? undefined : currencyForTimezone(timezone)
  return { ...draft, timezone, currency: followed ?? draft.currency }
}

export function toBranchRequest(draft: BranchDraft): CreateBranchRequest {
  return { slug: draft.slug, name: draft.name.trim(), timezone: draft.timezone, currency: draft.currency }
}
